<template>
  <div class="order-list">
    <h1>订单列表</h1>
    <!-- 添加复制提示 -->
    <div class="copy-tip">提示：可以选中文字按 Ctrl+C 复制，或双击单元格复制内容</div>
    
    <table>
      <thead>
        <tr>
          <th>订单ID</th>
          <th>用户名</th>
          <th>订单金额</th>
          <th>收货信息</th>
          <th>订单状态</th>
          <th>快递单号</th>
          <th>创建时间</th>
          <th>商品详情</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in orderList" :key="order.order_id">
          <td @dblclick="copyText(order.order_id)">{{ order.order_id }}</td>
          <td @dblclick="copyText(order.username || order.user_user_id)">{{ order.username || order.user_user_id }}</td>
          <td @dblclick="copyText('¥' + (order.price/100).toFixed(2))">¥{{ (order.price/100).toFixed(2) }}</td>
          <td @dblclick="copyText(getAddressText(order))">
            <div>{{ order.address_name }} {{ order.address_tel }}</div>
            <div class="address-detail">{{ order.address_area }} {{ order.address_detail }}</div>
            <div v-if="order.note" class="order-note">备注：{{ order.note }}</div>
          </td>
          <td @dblclick="copyText(getStatusText(order))">{{ getStatusText(order) }}</td>
          <td @dblclick="copyText(order.express_no || '')">{{ order.express_no || '未发货' }}</td>
          <td @dblclick="copyText(formatDate(order.create_time))">{{ formatDate(order.create_time) }}</td>
          <td>
            <div class="goods-list">
              <div v-for="goods in order.goods" :key="goods.goods_goods_id" class="goods-item">
                <img 
                  v-if="goods.image" 
                  :src="goods.image" 
                  :alt="goods.name"
                  class="goods-image"
                  @error="handleImageError"
                >
                <div class="goods-info">
                  <div class="goods-name">{{ goods.name }}</div>
                  <div class="goods-detail">
                    <span>单价：¥{{ (goods.price) }}</span>
                    <span>数量：{{ goods.count }}</span>
                    <span>详情：{{ goods.content }}</span>
                    <span>小计：¥{{ (goods.price * goods.count / 100).toFixed(2) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <button
              v-if="!order.is_cancel && !order.is_shipped"
              type="button"
              class="mui-btn mui-btn-primary"
              @click="shipOrder(order)"
            >发货</button>
            <button
              v-if="!order.is_cancel && !order.is_shipped"
              type="button"
              class="mui-btn mui-btn-danger"
              @click="cancelOrder(order)"
              style="margin-left:6px"
            >取消</button>
            <span v-else>{{ order.is_cancel ? '已取消' : '已发货' }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- 空状态显示 -->
    <div v-if="orderList.length === 0" class="empty-state">
      暂无订单数据
    </div>
    
    <!-- 复制成功提示 -->
    <div v-if="showCopyToast" class="copy-toast">
      复制成功！
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderList: [],
      showCopyToast: false,
      copyTimer: null
    };
  },
  mounted() {
    this.fetchOrderList();
  },
  methods: {
    fetchOrderList() {
      this.$http
        .get('/order/orders')
        .then((response) => {
          this.orderList = response.data.data || response.data;
        })
        .catch((error) => {
          console.error('获取订单列表失败:', error);
        });
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    handleImageError(e) {
      e.target.src = 'https://shaoermofangzhandui.asia/img/default.jpg';
      e.target.onerror = null;
    },
    getStatusText(order) {
      if (order.is_cancel) return '已取消';
      if (order.is_shipped) return '已发货';
      return '待发货';
    },
    shipOrder(order) {
      const expressNo = prompt(`请输入订单 ${order.order_id} 的快递单号：`, order.express_no || '');
      if (expressNo === null) {
        return;
      }

      const trimmedExpressNo = expressNo.trim();
      if (!trimmedExpressNo) {
        alert('快递单号不能为空');
        return;
      }

      this.$http
        .put(`/order/ship/${order.order_id}`, { expressNo: trimmedExpressNo })
        .then((response) => {
          alert(response.data.msg || '发货成功');
          this.fetchOrderList();
        })
        .catch((error) => {
          console.error('发货失败:', error);
          alert((error.response && error.response.data && error.response.data.msg) || '发货失败');
        });
    },
    cancelOrder(order) {
      if (!confirm(`确认取消订单 ${order.order_id} 吗？取消后积分将退还给用户。`)) {
        return;
      }
      this.$http
        .put(`/order/cancel/${order.order_id}`)
        .then((response) => {
          alert(response.data.msg || '取消成功');
          this.fetchOrderList();
        })
        .catch((error) => {
          console.error('取消失败:', error);
          alert((error.response && error.response.data && error.response.data.msg) || '取消失败');
        });
    },
    
    // 获取地址文本（用于复制）
    getAddressText(order) {
      let text = `${order.address_name} ${order.address_tel} ${order.address_area} ${order.address_detail}`;
      if (order.note) {
        text += ` 备注：${order.note}`;
      }
      return text;
    },
    
    // 复制文本功能
    copyText(text) {
      // 确保text是字符串
      const textToCopy = String(text);
      
      // 使用 Clipboard API 复制文本
      navigator.clipboard.writeText(textToCopy).then(() => {
        // 显示复制成功提示
        this.showCopyToast = true;
        
        // 清除之前的定时器
        if (this.copyTimer) {
          clearTimeout(this.copyTimer);
        }
        
        // 2秒后隐藏提示
        this.copyTimer = setTimeout(() => {
          this.showCopyToast = false;
        }, 2000);
      }).catch(err => {
        console.error('复制失败:', err);
        // 降级方案：使用传统的复制方法
        this.fallbackCopy(textToCopy);
      });
    },
    
    // 降级复制方案
    fallbackCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      
      try {
        document.execCommand('copy');
        this.showCopyToast = true;
        if (this.copyTimer) {
          clearTimeout(this.copyTimer);
        }
        this.copyTimer = setTimeout(() => {
          this.showCopyToast = false;
        }, 2000);
      } catch (err) {
        console.error('降级复制失败:', err);
        alert('复制失败，请手动选择复制');
      }
      
      document.body.removeChild(textarea);
    }
  }
};
</script>

<style scoped>
.order-list {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  /* 确保文本可选 */
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}

h1 {
  margin-bottom: 20px;
  color: #333;
}

/* 复制提示样式 */
.copy-tip {
  margin-bottom: 15px;
  padding: 8px 12px;
  background-color: #e3f2fd;
  color: #0d47a1;
  border-radius: 4px;
  font-size: 0.9em;
  border-left: 4px solid #2196f3;
}

table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
  vertical-align: top;
  /* 确保单元格内文本可选 */
  user-select: text;
  -webkit-user-select: text;
}

/* 添加复制光标提示 */
td {
  cursor: text;
}

/* 双击复制提示 */
td:hover {
  background-color: #f0f7ff;
  transition: background-color 0.2s;
}

th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
}

tr:hover {
  background-color: #f8f9fa;
}

.address-detail {
  font-size: 0.9em;
  color: #666;
  margin-top: 4px;
}

.order-note {
  font-size: 0.9em;
  color: #e67e22;
  margin-top: 4px;
  font-style: italic;
}

.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.85em;
  font-weight: 500;
}

.status-paid {
  background-color: #d4edda;
  color: #155724;
}

.status-unpaid {
  background-color: #fff3cd;
  color: #856404;
}

.status-cancel {
  background-color: #f8d7da;
  color: #721c24;
  margin-left: 5px;
}

.goods-list {
  max-width: 400px;
}

.goods-item {
  display: flex;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}

.goods-item:last-child {
  border-bottom: none;
}

.goods-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
  /* 图片不可复制 */
  user-select: none;
  -webkit-user-select: none;
  pointer-events: none;
}

.goods-info {
  flex: 1;
  min-width: 0;
}

.goods-name {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  word-break: break-word;
}

.goods-detail {
  font-size: 0.85em;
  color: #666;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.goods-detail span {
  white-space: nowrap;
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #999;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

/* 复制成功提示 */
.copy-toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  z-index: 1000;
  animation: fadeInOut 2s ease;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translate(-50%, 20px); }
  15% { opacity: 1; transform: translate(-50%, 0); }
  85% { opacity: 1; transform: translate(-50%, 0); }
  100% { opacity: 0; transform: translate(-50%, -20px); }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .order-list {
    padding: 10px;
  }
  
  table {
    font-size: 0.9em;
  }
  
  th,
  td {
    padding: 8px;
  }
}

/* 确保所有文本元素都可选 */
div, span, p, h1, h2, h3, h4, h5, h6 {
  user-select: text;
  -webkit-user-select: text;
}

/* 允许复制，但防止意外选中图片 */
img {
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}
</style>